import "./BroadcastModal.scss";
import BaseModal from "../UI/BaseModal/BaseModal";
import Input from "../UI/Input/Input";
import Button from "../UI/Button/Button";

export default function BroadcastModal({ handleClose, open }) {

  return (
    <BaseModal handleClose={handleClose} open={open}>
      <div className="post-entry-form-container container">
        <Input label={"Broadcast Message"} />
        <div className="d-flex justify-content-end mt-4">
          <Button buttonText={"Broadcast Message"} />
        </div>
      </div>
    </BaseModal>
  );
}
